// extracted by mini-css-extract-plugin
export default {"r_l":"_52ebfdc02a f2d9d50e08","t":"_8379937880"};